module.exports = __webpack_public_path__ + "static/fonts/Nunito-Light.adbc950.woff2";